import { Component, OnInit, Input } from '@angular/core';
import { FormGroup, FormBuilder } from '@angular/forms';
import { TotBatchService } from 'projects/services/src/app/API/tot-batch.service';
import { Helpers } from 'projects/training-calendar/src/app/helpers';
import { ApplicantDataService } from 'projects/services/src/app/applicant-data.service';
import { CurrentUserService } from 'projects/services/src/app/current-user.service';
import { Constants } from 'projects/shared/src/app/shared/constants/constants';
import { Subscription } from 'rxjs';
import { BatchService } from 'projects/services/src/app/API/batch.service';

import * as moment from 'moment';
declare const swal: any;
declare const toastr;

@Component({
	selector: 'app-search-applicant',
	templateUrl: './search-applicant.component.html',
	styleUrls: ['./search-applicant.component.css']
})
export class SearchApplicantComponent implements OnInit {
	sectors: any;
	subSectors: any;
	jobRoles: any;
	states: any;
	districts: any;
	subDistricts: any;
	batchTypes: any;
	data: any;
	searchResult: any;
	startDate = '';
	endDate = '';
	searchText = '';
	userInfo: any;
	isSearchDisabled = true;
	startDateObject = {
		date: '',
		placeholder: 'Select the Date',
		format: 'dd/MM/yyyy'
	};
	endDateObject = {
		date: '',
		placeholder: 'Select the Date',
		format: 'dd/MM/yyyy'
	};
	pageNum = 1;
	pageNo = 0;
	length = 10;
	recordsPerPage: number = Constants.RECORDSPERPAGE;
	showPreferenceButton = false;
	message: any;
	appliedBatch: any;
	subscription: Subscription;
	selectStatus = false;
	trainingRequestLists: any = [];
	searchBatchesForm: FormGroup;
	preferenceForm: FormGroup;
	loggedInUser: any;

	@Input() role: any;

	constructor(
		public _applicantDataService: ApplicantDataService,
		private _formBuilder: FormBuilder,
		private _totService: TotBatchService,
		private _batchService: BatchService,
		private currentUserService: CurrentUserService

	) {
		this.loggedInUser = this.currentUserService.decodeToken();
		this._applicantDataService.getBatchTypes(this.loggedInUser.role);
		this.searchBatchesForm = this._applicantDataService.searchBatchesForm;
		this.subscription = this._applicantDataService.getData().subscribe(message => {
			if (message.activeTab === 'batches') {
				console.log(message);
				this.search();
			}
		});
	}

	ngOnInit() {
		this.resetFormData();
		this.search();
	}

	createSearchData(data?, search?) {
		this.data = {
			state: data.state,
			district: data.district,
			subDistrict: data.subDistrict,
			sector: data.sector,
			// subSector: data.subSector,
			jobRole: data.jobRole,
			batchType: data.type,
			startDate: this.startDate,
			endDate: this.endDate,
			keyword: search ? search : '',
			sortBy: 'batchId'
		};
		if (this.startDate === '') {
			delete this.data.startDate;
		}
		if (this.endDate === '') {
			delete this.data.endDate;
		}
	}

	updateDataType() {
		Object.keys(this.data).forEach(key => {
			console.log('sdsfg', this.data[key]);
			if (this.data[key] === '') {
				console.log('key', key);
				this.data[key] = null;
				if (key === 'batchType') {
					this.data.batchType = '';
				}
				this.data.keyword = this.searchText === '' ? '' : 'tcName:' + this.searchText;
			}
		});
		console.log('data', this.data);
	}

	getSelectedData() {
		this.createSearchData(this.searchBatchesForm.value);
		console.log(this.data);
		if (this.data === undefined) {
			this.isSearchDisabled = true;
		} else {
			this.isSearchDisabled = false;
		}
	}

	search() {
		console.log("im called-2");
		this.createSearchData(this.searchBatchesForm.value);
		if (this.data === undefined) {
			this.isSearchDisabled = true;
		} else {
			this.isSearchDisabled = false;
		}
		this.updateDataType();
		this.setValidation(null);
		if (this.startDate) {
			this.data['startDate'] = this.startDate;
		}
		if (this.endDate) {
			this.data['endDate'] = this.endDate;
		}
		this._totService.getapplicantDataBySearch(this.data, this.pageNum, this.recordsPerPage).subscribe(
			res => {
				console.log(res, "myRes");
				this.searchResult = res.docs[0].data;
				this.length = res.docs[0].count;
			},
			error => {
				this.searchResult = [];
				console.log("myError");


			}
		);
		this.setValidation(null);
		this.resetFormData();
	}

	setValidation(validation?) {
		const fields = ['state', 'sector', 'jobRole'];
		fields.map(field => this.setValidationOnField(field, validation));
	}
	setValidationOnField(name, validation) {
		this.searchBatchesForm.get(name).setValidators(validation);
		this.searchBatchesForm.get(name).updateValueAndValidity();
	}

	resetFormData(name?: any) {
		console.log(this.data);
		this.isSearchDisabled = true;
		this.searchBatchesForm.get('state').setValue('');
		this.searchBatchesForm.get('district').setValue('');
		this.searchBatchesForm.get('subDistrict').setValue('');
		this.searchBatchesForm.get('sector').setValue('');
		// this.searchBatchesForm.get('subSector').setValue('');
		this.searchBatchesForm.get('jobRole').setValue('');
		this.searchBatchesForm.get('keyword').setValue('');
		this.searchBatchesForm.get('type').setValue('');
		if (name === 'date') {
			this.startDateObject.date = '';
			this.endDateObject.date = '';
			console.log('STRING');
		} else {
			this.startDateObject.date = '';
			this.endDateObject.date = '';
			console.log('NULL');
		}
		delete this.startDate;
		delete this.endDate;
		this._applicantDataService.districts = [];
		this._applicantDataService.subDistricts = [];
		// this._applicantDataService.subSectors = [];
		this._applicantDataService.jobRoles = [];
		this.searchBatchesForm.markAsUntouched();
		console.log(this.data);
		// this.search();
		console.log("I am called");

	}

	selectedStartDate(event) {
		if (String(event) !== 'Invalid Date') {
			console.log('not invalid');
			let date;
			date = moment(Helpers.toDateFromCalendar(event.toISOString())).startOf('day');
			date = moment(date._d).startOf('day').toISOString();
			date = new Date(date).toISOString();
			this.isSearchDisabled = false;
			this.startDate = date;
		} else {
			console.log('invalid');
		}
	}

	selectedEndDate(event) {
		if (String(event) !== 'Invalid Date') {
			let date;
			date = moment(Helpers.toDateFromCalendar(event.toISOString())).endOf('day');
			date = moment(date._d).endOf('day').toISOString();
			date = new Date(date).toISOString();
			this.isSearchDisabled = false;
			this.endDate = date;
		} else {
			console.log('invalid');
		}
	}

	setSearchText(search) {
		console.log(search);
		this.searchText = search;
		const searchData = 'tcName:' + this.searchText;
		if (search === '') {
			this.isSearchDisabled = true;
		} else {
			this.isSearchDisabled = false;
		}
		this.createSearchData(this.searchBatchesForm.value, searchData);
	}

	setPageNumber(pageNo: number) {
		this.pageNum = pageNo;
		// this.search();
	}
	setRecordsPerPage(recordsPerPage: number) {
		this.recordsPerPage = recordsPerPage;
		// this.search();
	}

	showViewlinkRequestModel(event) {
		console.log(this.role)
		if (event) {
			this.trainingRequestLists = [];
			if(event && event.data) {
				console.log('inside appliedBatch response......................');
				this.appliedBatch = JSON.parse(JSON.stringify(event.data))
			}
			const qpCode = this.getBatchJobRoles(this.appliedBatch)
			const data = {
				qpCodes: qpCode,
			}
			this._totService.getTrainingRequestListToLinkWithBatch(data, this.role).subscribe(res => {
				console.log(res);
				if (res && res.Approved.length && res.Approved[0]['preferences'] && res.Approved[0]['preferences'].length > 0) {
					this.trainingRequestLists = res.Approved[0].preferences;
					console.log(this.trainingRequestLists, this.appliedBatch,"CHECKING");
					Helpers.openModal('linkTrainingRequest');
				} else {
					this.linkTrainingRequest(res['Pending'])
				}
			})

		}
	}

	getBatchJobRoles(batch) {
		let jobRoles = []
		batch.jobRoles.map(jobRole => {
			jobRoles.push({
				'qpCode': jobRole.qpCode,
				'version': jobRole.version
			})
		});
		return jobRoles;
	}

	selectAll() {
		if (this.selectStatus) {
			this.selectStatus = false;
			for (let index = 0; index < this.trainingRequestLists.length; index++) {
				this.trainingRequestLists[index].isSelected = false;
			}
		} else {
			this.selectStatus = true;
			for (let index = 0; index < this.trainingRequestLists.length; index++) {
				this.trainingRequestLists[index].isSelected = true;
			}
		}
	}

	addJobRole() {

	}

	selectOne(index) {
		this.trainingRequestLists[index]['isSelected'] = !this.trainingRequestLists[index].isSelected;
	}

	resetAllCandidates() {
		this.selectStatus = false;
		for (let index = 0; index < this.trainingRequestLists.length; index++) {
			this.trainingRequestLists[index]['isSelected'] = false;
		}
	}

	linkTrainingRequest(pending?) {
		pending ? pending = pending : pending = [];
		let trainingRequest = [];
		if (this.trainingRequestLists.length > 0) {
			for (let index = 0; index < this.trainingRequestLists.length; index++) {
				if (this.trainingRequestLists[index].isSelected) {
					trainingRequest.push(this.trainingRequestLists[index].trainingReqId)
				}
			}
			const data = {
				trIds: trainingRequest,
				status: 'AWAITING_BATCH_ENROLLMENT',
				batchId: this.appliedBatch.batchId
			}
			if (trainingRequest.length > 0) {
				this._batchService.applyForBatch(this.appliedBatch.batchId, this.appliedBatch.type).subscribe(res => {
					console.log(res);
					if (res) {
						swal(
							'Applied Successfully',
							`You have successfully applied for ${this.appliedBatch.batchName},
							For next steps, please coordinate with concerned SSC.`,
							//  + 'and batch id - ' + data.batchId
							'success'
						);
						this._totService.linkTrainingRequestToBatch(data, this.role).subscribe(res => {
							console.log(res);
							if (res) {
								// swal('Training Request Updated Successfully', '', 'success');
								Helpers.closeModal('linkTrainingRequest');
							}
						})
					}
				});
			} else {
				toastr.error('Please select at least one Training request');
			}
		} else if (pending && pending.length > 0 && pending[0]['pendingCount'] > 0) {
			swal('Unable to process your request!', `You can't apply to the batch <b> ${this.appliedBatch.batchName} </b>
			 as your relevant Training Requests is under review by SSC.
			On receipt of approval from SSC, you would be able to apply to the batch.`, 'warning');
		} else {
			swal('No Training Request Raised', `You can't apply to the batch <b> ${this.appliedBatch.batchName} </b>
			as there is no Training Request raised in the specified job role.
			Please raise a Training Request, to proceed. The same shall be reviewed by the SSC.`, 'warning');
		}
	}

	// setData(): void {
	// 	this.searchResult = [];
	// 	this.prefrences.resetData();
	// 	this._applicantDataService.setData('data');
	// 	this.showPreferenceButton = true;
	// }

	// hideButton() {
	// 	this.searchResult = [];
	// 	this.showPreferenceButton = false;
	// 	// this.search();
	// }

	// addJobRole() {
	// 	const data = {
	// 		state: this.searchBatchesForm.value.state,
	// 		district: this.searchBatchesForm.value.district,
	// 		subDistrict: this.searchBatchesForm.value.subDistrict,
	// 		sector: this.searchBatchesForm.value.sector,
	// 		// subSector: this.searchBatchesForm.value.subSector,
	// 		jobRole: this.searchBatchesForm.value.jobRole,
	// 		batchType: this.searchBatchesForm.value.type ? this.searchBatchesForm.value.type : '',
	// 		startDate: this.startDate ? this.startDate : '',
	// 		endDate: this.endDate ? this.endDate : '',
	// 		keyword: this.searchText === '' ? '' : 'tcName:' + this.searchText
	// 	};
	// 	this.setValidation([Validators.required]);
	// 	if (this.searchBatchesForm.valid) {
	// 		this._totService.updateApplicantPreferences(data).subscribe(res => {
	// 			if (res) {
	// 				swal(
	// 					'Training Request Submitted Successfully',
	// 					'Successfully submitted job role and location preference as Training Request to SSC',
	// 					'success'
	// 				);
	// 				this.getAdditionalDetails();
	// 			}
	// 		});
	// 	} else {
	// 		toastr.error('Please select all sector details and state.');
	// 	}
	// 	this.resetFormData();
	// }

	// getAdditionalDetails() {
	// 	this.currentUserService.getAdditionalInfomartion().subscribe(data => {
	// 		this.userInfo = data;
	// 	});
	// }


}
